import { render, staticRenderFns } from "./AdminMain.vue?vue&type=template&id=60d3cd3a&"
import script from "./AdminMain.vue?vue&type=script&lang=js&"
export * from "./AdminMain.vue?vue&type=script&lang=js&"
import style0 from "./AdminMain.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
